"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_LINEAR_AD_EVENTS = exports.NON_LINEAR_AD_ENDED_EVENTS = exports.NON_LINEAR_AD_STARTED_EVENT = void 0;
// These event names are currently emitted only for pause ads. They are not yet part of the
// `PlayerEvent` enum of the player version this UI builds against.
exports.NON_LINEAR_AD_STARTED_EVENT = 'nonlinearadstarted';
exports.NON_LINEAR_AD_ENDED_EVENTS = ['nonlinearadfinished', 'nonlinearadskipped'];
exports.NON_LINEAR_AD_EVENTS = __spreadArray([exports.NON_LINEAR_AD_STARTED_EVENT], exports.NON_LINEAR_AD_ENDED_EVENTS, true);
